
<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>Select an option</mat-label>
        <mat-select  (selectionChange)="OpenDialogPDFpalletlabel($event.value)">
          <mat-option *ngFor="let item of arraydata" [value]="item">{{item.ID}}</mat-option>
          
        </mat-select>
      </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
 
</div>